import React, { Component } from "react";
import { Link } from "react-router";
import { Divider, Button } from "../Controls";

import "./styles.less";

import UMeImage from "../../assets/images/u-me.svg";
import CrownImage from "../../assets/images/crown.svg";
import InputElement from "react-input-mask";
import texts from "../../assets/strings/details.js";
class DetailsMobile extends Component {
  inputOnBlur(currentPage, section, evt, idx) {
    this.props.detailsFieldOnBlur(currentPage, section, evt.target.value, idx);
  }

  inputOnChange(currentPage, section, evt, idx) {
    this.props.detailsFieldOnChange(
      currentPage,
      section,
      evt.target.value,
      idx
    );
  }

  addInput(currentPage, section) {
    this.props.detailsAddField(currentPage, section);
  }

  deleteInput(currentPage, section, idx) {
    this.props.detailsDeleteField(currentPage, section, idx);
  }

  renderInput(currentPage, section, field, idx, isLast) {
    return (
      <li className="inputWrapper" key={`${section.key}-${idx}`}>
        <label className="inputLabel">{section.label}:</label>
        {field.mask ? (
          <InputElement
            className={`${
              field.valid === true
                ? "valid"
                : field.valid === false
                  ? "invalid"
                  : ""
            }`}
            mask={field.mask}
            value={field.value}
            type={field.type}
            placeholder={texts[currentPage].placeholder}
            onChange={evt =>
              this.inputOnChange(currentPage, section.key, evt, idx)
            }
            onBlur={evt => this.inputOnBlur(currentPage, section.key, evt, idx)}
          />
        ) : (
          <input
            className={`${
              field.valid === true
                ? "valid"
                : field.valid === false
                  ? "invalid"
                  : ""
            }`}
            value={field.value}
            type={field.type}
            placeholder={texts[currentPage].placeholder}
            onChange={evt =>
              this.inputOnChange(currentPage, section.key, evt, idx)
            }
            onBlur={evt => this.inputOnBlur(currentPage, section.key, evt, idx)}
          />
        )}
        {/* {isLast && field.valid ? (
          <a
            className="inputAction primary"
            onClick={() => this.addInput(currentPage, section.key)}
          >
            + Add
          </a>
        ) : idx !== 0 ? (
          <a
            className="inputAction accent"
            onClick={() => this.deleteInput(currentPage, section.key, idx)}
          >
            - Delete
          </a>
        ) : null} */}
      </li>
    );
  }

  render() {
    const currentPage = this.props.routeParams.section || "personal",
      {
        reducer,
        reducer: { sections }
      } = this.props,
      page = reducer[currentPage],
      links = {
        personal: {
          next: "/details/target",
          prev: "/proceed"
        },
        target: {
          next: "/message",
          prev: "/details/personal"
        },
        response: {
          next: "/message",
          prev: "/proceed"
        }
      };
    console.log(texts[currentPage].actions.prev);
    return (
      <div className="details mobile">
        <section className="detailsWrapper">
          <h1>{texts[currentPage].h1}</h1>
          {texts[currentPage].note && (
            <p className="note">{texts[currentPage].note}</p>
          )}
          <div className="detailsInputs">
            {Object.keys(sections).map(section => (
              <ul key={`section-${section}`}>
                {page[section].map((field, idx) =>
                  this.renderInput(
                    currentPage,
                    sections[section],
                    field,
                    idx,
                    page[section].length === idx + 1
                  )
                )}
              </ul>
            ))}
          </div>
        </section>
        <section className="controls">
          <Button large={true} accent={true}>
            <Link to={links[currentPage].prev}>
              {texts[currentPage].actions.prev}
            </Link>
          </Button>
          <Button primary={true} large={true} disabled={!page.valid}>
            {page.valid ? (
              <Link to={links[currentPage].next}>
                {texts[currentPage].actions.next}
              </Link>
            ) : (
              <span>{texts[currentPage].actions.next}</span>
            )}
          </Button>
        </section>
      </div>
    );
  }
}
export default DetailsMobile;



// WEBPACK FOOTER //
// ./components/Details/DetailsMobile.js